<template>
  <div class="centralized-issues-tld-table-cell" :title='item.tld'>
    <span class='centralized-issues-tld-table-cell__tld'> {{ item.tld }} </span>
  </div>
</template>

<script>
export default {
  name: 'TldTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.centralized-issues-tld-table-cell {
  z-index: 10;
  color: var(--text-primary);
  display: flex;
  font-family: $font-family-bold;
  font-size: rem(14);
  font-weight: bold;
  letter-spacing: 0;
  line-height: rem(17);
  flex-direction: column;
  justify-content: center;
  width: rem(190);
  &__tld {
    width: rem(190);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
